import ReactDOM from 'react-dom/client';
import App from './App';

// StrictMode intentionally omitted. In dev it double-invokes effects, and
// with @clerk/clerk-react's SignUp component that causes two verification
// codes to be sent back-to-back (invalidating the first). Even in prod
// builds the extra mount cycle interacts badly with Clerk's state machine
// on slow networks. The lint benefit isn't worth the UX regression.
ReactDOM.createRoot(document.getElementById('root')).render(<App />);
